module.exports = __webpack_public_path__ + "img/shuiweir.22428529.png";